export class CacheEntry<T> {
  data: T;
  timestamp: number;

  constructor(data: T, timestamp: number = Date.now()) {
    this.data = data;
    this.timestamp = timestamp;
  }

  static isCacheValid(timestamp: number, cacheDuration: number): boolean {
    const now = Date.now();
    return (now - timestamp) < cacheDuration;
  }

  isValid(cacheDuration: number): boolean {
    return CacheEntry.isCacheValid(this.timestamp, cacheDuration);
  }
}

